import { render, staticRenderFns } from "./CaregivingResources.vue?vue&type=template&id=2f2f3e60"
import script from "./CaregivingResources.vue?vue&type=script&lang=js"
export * from "./CaregivingResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports